import clsx from 'clsx';
import type { ReactNode } from 'react';

interface RowSelectionProps {
  children?: ReactNode;
  className?: string;
  selectedItems: any[];
  label: string;
}

export function RowSelection({ children, className, selectedItems, label }: RowSelectionProps) {
  if (selectedItems.length === 0) {
    return null;
  }

  return (
    <div className={clsx('fixed right-0 bottom-0 left-0 z-[9999] mx-auto flex h-20 items-center justify-between border-gray-200 border-t bg-white px-8 py-4 shadow-lg', className)}>
      <span className="text-grey-label text-lg">{label}</span>
      {children}
    </div>
  );
}
